import { IconRTEClose } from 'components/Icons';
import '../AttachmentContainer/AttachmentsContainer.scss';
import './AttachmentItem.scss';
import { AttachmentItemType } from '../AttachmentContainer/AttachmentsContainer';
import AttachmentIcon from './AttachemntItemIcon/AttachmentIcon';

export type UploadProgress = {
  percentage: number;
  status: 'pending' | 'uploading' | 'success' | 'error';
  errorMessage?: string;
};

type AttachmentsItemProps = {
  attachment: AttachmentItemType;
  onRemove: (id: number) => void;
};

const AttachmentItem = ({ attachment, onRemove }: AttachmentsItemProps) => {
  // Progress bar for attachments that are uploading/processing
  const getProgressBar = (progress: number) => {
    // Ensure progress is within the valid range (0 to 100)
    const clampedProgress = Math.max(0, Math.min(100, progress));

    // Calculate the width of the progress fill based on the progress value
    const progressFillWidth = `${clampedProgress}%`;

    return (
      <div className="attachment-item-icon-container-progress-bar">
        <div
          className="attachment-item-icon-container-progress-bar-progress-fill"
          style={{ width: progressFillWidth }}
        ></div>
      </div>
    );
  };

  return (
    <div className="attachment-item">
      <div className="attachment-item-icon-container">
        <div className="attachment-item-icon-container-icon">
          <AttachmentIcon attachamentType={attachment.type} />
        </div>
        <button onClick={() => onRemove(attachment.id)} className="attachment-item-icon-container-remove-button">
          <IconRTEClose />
        </button>
      </div>
      {attachment.processing?.status === 'error' && (
        <span className="attachment-item-error">{attachment.processing?.errorMessage}</span>
      )}
      {attachment.processing?.status === 'success' && <span className="attachment-item-name">{attachment?.name}</span>}
      {attachment.processing?.status === 'uploading' && getProgressBar(attachment.processing?.percentage)}
    </div>
  );
};

export default AttachmentItem;
